import { VisuallyHiddenHybrid } from "./VisuallyHiddenHybrid";
import type { VisuallyHiddenProps } from "./VisuallyHiddenStyled";

export type { VisuallyHiddenProps };

// This wrapper component is needed for react-docgen to work.
// It has issues with generating docs for the implementation directly.
export const VisuallyHidden = (props: VisuallyHiddenProps) => (
  <VisuallyHiddenHybrid {...props} />
);
